import { AVAILABLE_ICONS } from "@/components/admin/IconSelector";
import {
  Bell,
  Trophy,
  Users,
  Lock,
  Check,
  Star,
  Gift,
  Award,
  Target,
  Bookmark,
  Calendar,
  Info,
  MessageCircle,
  Settings,
  type LucideIcon,
} from "lucide-react";

/**
 * Extended icon map: AVAILABLE_ICONS (43 curated) + extras needed by the app.
 * This replaces `import * as LucideIcons` to enable tree-shaking (~900KB savings).
 */
const EXTENDED_ICONS: Record<string, LucideIcon> = {
  ...AVAILABLE_ICONS,
  Bell,
  Trophy,
  Users,
  Lock,
  Check,
  Star,
  Gift,
  Award,
  Target,
  Bookmark,
  Calendar,
  Info,
  MessageCircle,
  Settings,
};

/**
 * Resolve an icon name to a LucideIcon component.
 * Returns `fallback` if the name is not found in the curated map.
 */
export function getDynamicIcon(
  name: string | null | undefined,
  fallback: LucideIcon = Bell
): LucideIcon {
  if (!name) return fallback;
  return EXTENDED_ICONS[name] ?? fallback;
}

/**
 * React component for rendering a dynamic icon by name.
 */
export function DynamicIcon({
  name,
  fallback,
  className,
  size,
}: {
  name: string | null | undefined;
  fallback?: LucideIcon;
  className?: string;
  size?: number;
}) {
  const Icon = getDynamicIcon(name, fallback);
  return <Icon className={className} size={size} />;
}
